const classNames = require('classnames')
const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const $ = require('lib/jquery')
const template = require('./banner.html')
const styles = require('./banner.less')
const Escape = require('lib/escape')
const radio = require('lib/radio')
const getZindex = require('lib/zindex')
const log = require('log').create('banner')  

const valid_statuses = [
    'info',
    'confirmation',
    'warning',
    'error',
]

const Banner = Marionette.View.extend({

    displayName: 'Banner',

    template,

    styles,

    className() {
        const { status, optionsClassName } = this.options
        return classNames([
            'layer',
            'banner',
            `banner-${status}`,
            optionsClassName,
        ], {
            'has-close-button': this.options.close_button,
        })
    },

    ui: {
        banner: '.banner-content',
        content: '.message-content',
        close: '.banner-close',
    },

    events: {
        'click @ui.close': 'onClickClose',
        'mouseenter @ui.banner': 'clearFadeTimer',
        'mouseleave @ui.banner': 'startFadeTimer',
    },

     
    constructor: function constructor(options) {

        // sometimes the options object passed in is a react props object, which
        // is apparently immutable, so we make our own opts object and apply our
        // defaults to it

        const opts = _.defaults({}, options, {
            close_button: true,
            close_on_escape: true,
            status: 'confirmation',
            duration: 5000,
            fade_duration: 500,
            viewClass: null,
            viewOptions: {},
            html: null,
            text: null,
        })

        // validate the status
        if (! _.contains(valid_statuses, opts.status)) {
            throw new Error(`Invalid banner status: ${opts.status}`)
        }

        // don't allow options.className to override our className method.
        // move it aside, and let the className method apply it from there
        opts.optionsClassName = opts.className
        delete opts.className

        Marionette.View.apply(this, [opts])

    },

    initialize() {
        _.bindAll(this, 'destroy', 'fadeOut')

        // banners render and show themselves when created
        this.render()
        this.show()
    },

    templateContext() {
        const templateContext = {}
        templateContext.options = _.pick(this.options, 'close_button')
        return templateContext
    },

    onRender() {
        if (this.options.viewClass) {
            this.addRegion('content', { el: this.ui.content })
            // eslint-disable-next-line new-cap
            const view = new this.options.viewClass(this.options.viewOptions)
            this.showChildView('content', view)
        } else if (this.options.html) {
            this.ui.content.html(this.options.html)
        } else if (this.options.text) {
            this.ui.content.text(this.options.text)
        } else {
            throw new Error('Banner requires a text or html string, or a view class.')
        }
    },

    show() {
        log('showBanner', this.cid)

        this.$el.css('z-index', getZindex())
        $.layers.append(this.el)

        if (this.ui.content.height() > 50) {
            this.$el.addClass('large')
        }

        radio.dialog.trigger('banner:open')

        this.listenTo(radio.dialog, 'banner:open dialog:open menu:topnav:open carousel:scroll', () => {
            this.fadeOut(200)
        })
        this.listenTo(radio.dialog, 'dialog:open', () => {
            this.fadeOut(100)
        })

        if (this.options.close_on_escape) {
            Escape.listen(this.cid, this.fadeOut)
        }

        this.startFadeTimer()
    },

    onClickClose() {
        this.fadeOut()
    },

    fadeOut(speed) {
        this.clearFadeTimer()
        if (_.isUndefined(speed)) {
            // eslint-disable-next-line no-param-reassign
            speed = this.options.fade_duration
        }
        this.$el.css('transition', `opacity ${speed}ms ease-out`)
        this.$el.addClass('fade-out')
        _.delay(this.destroy, speed + 100)
    },

    startFadeTimer() {
        if (! this.options.duration) return
        this.clearFadeTimer()
        this.fade_timer = setTimeout(this.fadeOut, this.options.duration)
    },

    clearFadeTimer() {
        clearTimeout(this.fade_timer)
    },

    onBeforeDestroy() {
        this.clearFadeTimer()
        if (this.options.close_on_escape) {
            Escape.unlisten(this.cid)
        }
        if (_.isFunction(this.options.close)) this.options.close.call(this)
    },

})

module.exports = Banner
